import React from "react";
import { Col, Row } from "react-bootstrap";
import { Md5Field, VersionField } from "./VersionField";

interface Props {
  versionControlId: string;
  versionLabel: string;
  versionPlaceholder: string;
  versionPattern: RegExp;
  versionInvalidMessage: string;
  version: string | undefined;
  onVersionChange: (value: string) => void;
  md5ControlId?: string;
  md5Label?: string;
  md5Value?: string;
}

export function ArtifactRow({
  versionControlId,
  versionLabel,
  versionPlaceholder,
  versionPattern,
  versionInvalidMessage,
  version,
  onVersionChange,
  md5ControlId,
  md5Label,
  md5Value,
}: Props) {
  return (
    <Row className="mb-3 ps-4">
      <Col>
        <VersionField
          controlId={versionControlId}
          label={versionLabel}
          placeholder={versionPlaceholder}
          value={version}
          pattern={versionPattern}
          invalidMessage={versionInvalidMessage}
          onChange={onVersionChange}
        />
      </Col>
      <Col>
        {md5Label && md5ControlId && (
          <Md5Field controlId={md5ControlId} label={md5Label} value={md5Value} />
        )}
      </Col>
    </Row>
  );
}
